import React from 'react';
export const StatsBar = () => {
  return <div className="bg-navy-800 border-y border-navy-700 py-6" data-id="element-322">
      <div className="max-w-6xl mx-auto px-4" data-id="element-323">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-navy-700" data-id="element-324">
          <div data-id="element-325">
            <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-326">
              +1.200
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-327">
              familias confían
            </div>
          </div>
          <div data-id="element-328">
            <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-329">
              6
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-330">
              Tomos listos
            </div>
          </div>
          <div data-id="element-331">
            <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-332">
              4
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-333">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-334">
            <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-335">
              4.9/5
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-336">
              calificación ⭐
            </div>
          </div>
        </div>
      </div>
    </div>;
};